function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var dmEnvironment = {
  host: window.LEO_BASE_URL || "",
  mediaHost: window.LEO_BASE_URL_MEDIA || "",
  baseUrl: "/",
  baseUrlMedia: "/",
  defaultLimitResults: +(window.LEO_LIMIT_RESULTS || 50),
  leoEnvoyUrl: window.LEO_ENVOY_ADMIN_URL || ""
};
var ACCOUNT_STATUS;
(function(ACCOUNT_STATUS2) {
  ACCOUNT_STATUS2[ACCOUNT_STATUS2["PENDING"] = 0] = "PENDING";
  ACCOUNT_STATUS2[ACCOUNT_STATUS2["ACTIVE"] = 1] = "ACTIVE";
  ACCOUNT_STATUS2[ACCOUNT_STATUS2["ON_BOARDING"] = 2] = "ON_BOARDING";
  ACCOUNT_STATUS2[ACCOUNT_STATUS2["REJECTED"] = 3] = "REJECTED";
})(ACCOUNT_STATUS || (ACCOUNT_STATUS = {}));
var TEN_MINUTES = 6e5;
var Config = /* @__PURE__ */ _createClass(function Config2() {
  _classCallCheck(this, Config2);
});
Config.production = window.LEO_ENVIRONMENT !== "development" && window.LEO_ENVIRONMENT !== "dev";
Config.dmEnvironment = dmEnvironment;
Config.version = window.LEO_VERSION;
Config.debug = window.LEO_DEBUG;
Config.cacheTimeout = +window.CACHE_TIMEOUT || TEN_MINUTES;
Config.accountStatus = ACCOUNT_STATUS;
Config.logLevel = window.LEO_LOGLEVEL;
export {Config};
